// src/App.js
import React, { useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { fetchUser } from './componet/service';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import BorrowPage from './pages/BorrowPage';
import BorrowHisPage from './pages/BorrowHisPage';
import BorrowDetailPage from './pages/BorrowDetailPage';
import TransferApplyPage from './pages/TransferApplyPage';
import ApproveHisPage from './pages/ApproveHisPage';
import ApproveDetailPage from './pages/ApproveDetailPage';
import AvailableDevicePage from './pages/AvailableDevicePage';


// 应用入口组件
function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const checkLogin = async () => {
    const token = localStorage.getItem('token');
    try {
      if (token) {
        const res = await fetchUser(token);
        if (res.code === 0) {
          setLoggedIn(true);
        } else {
          localStorage.removeItem("token");
          setLoggedIn(false);
        }
      } else {
        setLoggedIn(false);
      }
    } catch (err) {
      localStorage.removeItem("token");
      setLoggedIn(false);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    // 检查用户是否已登录
    checkLogin();
  }, []);
  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      {/* 这里可以添加一个加载指示器组件 */}
    </div>;
  }
  return (
    <Router basename='mobile'>
      <Routes>
        <Route path="/login" element={loggedIn ? <Navigate to="/" /> : <LoginPage onLogin={() => setLoggedIn(true)} />}>
        </Route>
        <Route path="/" element={loggedIn ? <MainPage /> : <Navigate to="/login" />}>
        </Route>
        <Route path="/borrow" element={loggedIn ? <BorrowPage /> : <Navigate to="/login" />}>
        </Route>
        <Route path="/borrow-his" element={loggedIn ? <BorrowHisPage /> : <Navigate to="/login" />}>
        </Route>
        <Route path="/borrow-detail/:id" element={loggedIn ? <BorrowDetailPage /> : <Navigate to="/login" />}>
        </Route>
        <Route path="/transfer-apply" element={loggedIn ? <TransferApplyPage /> : <Navigate to="/login" />}></Route>
        <Route path="/approve-his" element={loggedIn ? <ApproveHisPage /> : <Navigate to="/login" />}>
        </Route>
        <Route path="/approve-detail/:id" element={loggedIn ? <ApproveDetailPage /> : <Navigate to="/login" />}>
        </Route>
        <Route path="available-devices" element={loggedIn ? <AvailableDevicePage /> : <Navigate to="/login" />}>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
